/* Built In Imports */

/* External Imports */
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Icon,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';

/* Internal Imports */
/* Component */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';

/* Styles */
/* Services */

/**
 *
 * @returns
 */
const MobMenu = ({ title, setMIndex, mIndex, headerData }) => {
  const data = headerData[mIndex];
  const isProduction = data.key === 'productions';
  return (
    <ListItem w="100%" padding=".5rem 1rem" mt="1rem">
      <Text
        fontSize="1rem"
        fontFamily="var(--FedraSansStd-medium)"
        textTransform="uppercase"
        color="#60ADFF"
        mb="12px"
      >
        <Icon
          onClick={() => setMIndex(-1)}
          cursor="pointer"
          width="24px"
          height="24px"
          viewBox="0 0 24px 24px"
          fill="none"
        >
          <path
            d="M10.5 19L3.5 12L10.5 5M20.5 12L4 12"
            stroke="#60ADFF"
            stroke-width="2"
          />
        </Icon>
        <Link
          href={refineUrlDomain(data.url)}
          _focus={{ boxShadow: 'none' }}
          prefetch
        >
          {data.title}
        </Link>
      </Text>
      {isProduction && (
        <Text
          fontSize="14px"
          fontFamily="var(--FedraSansStd-book)"
          color="#fff"
          mb="12px"
          pl="1.8rem"
        >
          {/*  
                    <Link
                    href={refineUrlDomain(data.url)}
                        _focus={{ boxShadow: "none" }}> {data.title}</Link>
                 */}
          Our Repertoire
        </Text>
      )}

      <Box>
        <Box mx="auto">
          <Box>
            {/* <List className="ul-reset"> */}
            {data.submenuItems.map(sub => {
              if (sub.submenuItems.length > 0 && !isProduction) {
                return (
                  <Accordion allowToggle fontFamily="var(--FedraSansStd-book)">
                    <AccordionItem border="none">
                      {({ isExpanded }) => (
                        <>
                          <Heading
                            as="h3"
                            color="#fff"
                            fontFamily="var(--FedraSansStd-medium)"
                          >
                            <AccordionButton border="none">
                              <Box as="span" flex="1" textAlign="left">
                                <Link
                                  href={refineUrlDomain(sub.url)}
                                  _focus={{ boxShadow: 'none' }}
                                  prefetch
                                >
                                  {sub.title}
                                </Link>
                              </Box>
                              {isExpanded ? (
                                <MinusIcon fontSize="12px" />
                              ) : (
                                <AddIcon fontSize="12px" />
                              )}
                            </AccordionButton>
                          </Heading>
                          <AccordionPanel pb={4} pl="2rem">
                            <List listStyleType="none" color="#FEFAF6">
                              {sub?.submenuItems.map(subMenu => {
                                return (
                                  <ListItem py="8px">
                                    <Link
                                      href={refineUrlDomain(subMenu.url)}
                                      fontFamily="var(--FedraSansStd-book)"
                                      _focus={{ boxShadow: 'none' }}
                                      prefetch
                                    >
                                      {subMenu.title}
                                    </Link>
                                  </ListItem>
                                );
                              })}
                            </List>
                          </AccordionPanel>
                        </>
                      )}
                    </AccordionItem>
                  </Accordion>
                );
              } else {
                return (
                  <Box padding=".5rem 1rem .5rem 2.5rem">
                    <Link
                      fontFamily="var(--FedraSansStd-medium)"
                      _focus={{ boxShadow: 'none' }}
                      href={refineUrlDomain(sub.url)}
                      color="#fff"
                      prefetch
                    >
                      {sub?.title}
                    </Link>
                  </Box>
                );
              }
            })}
          </Box>
        </Box>
      </Box>
    </ListItem>
  );
};

export default MobMenu;
